<template>
    <div class="row h-100">
        <div class="col-sm-10 col-md-11 col-lg-8 my-auto mx-auto">
            <div class="row">
                <div class="col-md-6 bg-white py-5 px-5">
                    <div class="row">
                        <div class="col-12 px-5 px-md-2">

                            <h1 class="text-center">
                                <i class="fas fa-exclamation-triangle text-warning mb-3"></i><br>
                                <span>Page Not Found</span>
                            </h1>

                            <div class="text-center my-4">
                                <p class="text-muted mb-3">
                                    Sorry, the page you are looking for could not be found.
                                </p>
                                <div class="alert alert-light border" role="alert">
                                    <strong>Requested URL:</strong><br>
                                    <code>{{ currentUrl }}</code>
                                </div>
                            </div>

                            <div class="text-center">
                                <router-link 
                                    to="/" 
                                    class="btn btn-outline-primary mt-4 py-2 px-4"
                                >
                                    <i class="fas fa-home me-2"></i>
                                    Back to Dashboard
                                </router-link>
                            </div>

                            <div class="text-center my-3">
                                <span class="text-muted">
                                    Need help? 
                                    <a href="mailto:support@7thleveltech.com" class="text-muted">Contact Support</a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 bg-login p-0">
                    <div class="bg h-100 d-flex py-3">
                        <div class="text-center my-auto text-white w-50 mx-auto">
                            <h4>
                                <img src="/images/favicon.png" alt="7th Level Technologies" style="width: 25%; max-width: 100%; height: auto;" class="mb-3"><br />
                                Manage project time and resources with ease.
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();

const currentUrl = computed(() => {
    return window.location.href;
});
</script>

<style>

#app.notfound {
  background: #212121;
}

</style>
